<script>
import XLSX from "xlsx";
export default {
    name: "UploadStock",
    props: {
        modalTitle: {
            type: String,
            default: "Upload Excel",
        },
    },
    data() {
        return {
            excelList: null,
            selectedFile: null,
            isUploading: false,
        };
    },
    methods: {
        renderExcel(event) {
            this.file = event.target.files ? event.target.files[0] : null;
            if (this.file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const bstr = e.target.result;
                    const wb = XLSX.read(bstr, { type: "binary" });
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_json(ws);
                    const excellist = [];
                    for (var i = 0; i < data.length; i++) {
                        excellist.push(data[i]);
                    }
                    this.excelList = excellist;
                };
                reader.readAsBinaryString(this.file);
            }
        },
        uploadExcel() {
            this.$emit('upload-excel', this.excelList);
        },
    },
};
</script>
<template>
    <b-modal
      id="modal-excel"
      title="Upload Excel"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form class="needs-validation" ref="usForm">
        <div class="input-group">
          <input
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            class="form-control"
            id="inputGroupFile04"
            aria-describedby="inputGroupFileAddon04"
            aria-label="Upload"
            @change="renderExcel"
          />
        </div>
        <slot name="additional" />
        <div class="d-flex flex-row-reverse">
          <button
            class="btn btn-primary mt-3"
            type="button"
            id="inputGroupFileAddon04"
            @click="uploadExcel"
          >
            Upload
          </button>
        </div>
      </form>
    </b-modal>
</template>